import { z } from 'zod';
import { languageCodeSchema } from '../facility';

export const messagingSettingsSchema = z.object({
  // Send from the common Eleggia Twilio number instead of the organization's
  // own (XT-758).
  useSharedSender: z.boolean(),
  // Whether own Twilio credentials are configured — never the credentials.
  hasOwnSender: z.boolean(),
  // The organization whose templates every other organization inherits
  // (TempoVIP). It always sends from the common number.
  isDefaultTemplateOrganization: z.boolean(),
  // Language every message uses when a template exists in it, ahead of the
  // itinerary's language. Null = the itinerary's language.
  defaultLanguageCode: z.string().nullable(),
});
export type MessagingSettings = z.infer<typeof messagingSettingsSchema>;

export const updateMessagingSettingsInput = z
  .object({
    useSharedSender: z.boolean().optional(),
    defaultLanguageCode: languageCodeSchema.nullable().optional(),
  })
  .refine(
    (input) =>
      input.useSharedSender !== undefined ||
      input.defaultLanguageCode !== undefined,
    { message: 'Nothing to update' }
  );
export type UpdateMessagingSettingsInput = z.infer<
  typeof updateMessagingSettingsInput
>;
